import { Tabs, TabsList, TabsContent, TabsTrigger } from '@/components/shadcn/ui/tabs';
import { FormProvider, useForm, useFormContext } from 'react-hook-form';
import negocio from '@/validations/schemas/negocio';
import { zodResolver } from '@hookform/resolvers/zod';
import { ProductWithBusinessProvider, useProductWithBusinessContext } from './ProductWithBusinessContext';
import { useBusinessDetailContext } from '@/context/BusinessDetailContext';
import { useEffect, useState } from 'react';
import { BusinessUpdateInterface } from '@/entities/business';
import { useBusiness } from '@/hook/useBusiness';
import { useParams, useSearchParams } from 'react-router-dom';
import { useAuthContext } from '@/context/AuthContext';
import React from 'react';
import { toast } from '@/components/shadcn/ui/use-toast';
import InfoCliente from './Infocliente';
import ProductLev from './ProductLev';
import EmailConfigPage from '@/pages/marketing/setting/SettingEmail';
import EmailTemplatesPage from '@/pages/marketing/template/TemplateEmail';
import EmailPageLev from './SendEmailLev';
import Situation from './Situation';
import Details from './Details';
import PrintComponent from '@/document/basicDocument';
import UserBusiness from '@/pages/userBusiness/userBusiness';
function FormLev() {
  const methods = useForm({ resolver: zodResolver(negocio) });
  const {businessEdit, business, businessEdit2, setBusinessEdit2, fetchbusinessById} = useBusinessDetailContext();
  const {selectedProducts} = useProductWithBusinessContext();
  const { updateBusiness } = useBusiness();
  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab");
  const [tabValue, setTabValue] = useState(tab? tab : 'infocliente');
  useEffect(()=>{
    
    fetchbusinessById();
    // console.log(business);
  },[]);


  const {leadId} = useParams<{leadId:string}>();
  const leadId2Set = Number(leadId);
  const {business2} = useBusiness(leadId2Set);
  const {accessToken} = useAuthContext(); 

  const onSubmit = async (data: any) =>{
    
    const updateData:BusinessUpdateInterface = {
      description: data.descricao,
      contactNumber: data.tel,
      observation: data.observacao,
      prevision: data.previsao,
      closedAt: data.dtfechamento,
      reason:data.motivo,
      status: data.situacao,
      startedAt: data.dtinicio,
      updatedAt: new Date(),
      clientId: data.client,
      activityTypesId: data.idtiponegocio,
      businessSourceId: data.idfontenegocio
    };
    // console.log(updateData);
    const result = await updateBusiness(leadId2Set,updateData);

    if(result != undefined){if (result.success) {
      toast({ description: "Dados alterados com sucesso!" });
    } else {
      toast({ description: "Ocorreu um erro! Dados não foram salvos.\n Preencha todos os campos", variant: "destructive" });
    }}
    

  };

  return (
    <div className='bg-indigo-200 mb-8 border-l border-slate-200'>
      <FormProvider {...methods}>
        <div className='flex flex-col bg-indigo-200'>
          {business2?.opportunityFlowId == 3 ? 
         ( <div className='flex flex-col'>
          <Tabs defaultValue='template' className='w-full bg-inherit'>
            <TabsList className='grid bg-white w-full grid-cols-3 border-b p-0 m-0 rounded-0'>
              <TabsTrigger value='template'>1 . Templates de Assunto</TabsTrigger>
              <TabsTrigger value='proposta'>2 . Proposta</TabsTrigger>
              <TabsTrigger value='envio'> 3 . Envio da Proposta</TabsTrigger>
            </TabsList>
            <TabsContent value='template' className='w-full'>
              <EmailTemplatesPage/>
            </TabsContent>
            <TabsContent value='envio' className='w-full'>
              <EmailPageLev/>
            </TabsContent>
            <TabsContent value='proposta' className='w-full'>
              <PrintComponent/>
            </TabsContent>
          </Tabs> 
          </div>)
           : business2?.opportunityFlowId == 4 ?
          ( <div className='flex flex-col'>
           <Tabs defaultValue='situation' className='w-full bg-inherit'>
             <TabsList className='grid w-full bg-white grid-cols-1 border-b p-0 m-0 rounded-0'>
               <TabsTrigger value='situation'>1 . Situação</TabsTrigger>
             </TabsList>
             <TabsContent value='situation' className='w-full flex items-center justify-center'>
               <Situation/>
             </TabsContent>
           </Tabs> 
           </div>)
           : business2?.opportunityFlowId == 1 ?
          (
            <div className='flex flex-col'>
          <Tabs defaultValue='colaboradores' className='w-full bg-indigo-200'>
            <TabsList className='grid w-full bg-white grid-cols-1 border-b rounded-0'>
              <TabsTrigger value='colaboradores'>1 . Colaboradores</TabsTrigger>
            </TabsList>
            <TabsContent value='colaboradores' className='w-full bg-white'>
              <UserBusiness />
            </TabsContent>
          </Tabs>
          </div>) : 
          (<Tabs defaultValue={tabValue} onValueChange={setTabValue} className='w-full bg-indigo-200'>
            <TabsList className='grid w-full bg-white grid-cols-2 border-b rounded-0'>
              <TabsTrigger value='infocliente'>1 . Lev. Info Cliente</TabsTrigger>
              <TabsTrigger value='necessidades'>2 . Lev. Necessidades</TabsTrigger>
            </TabsList>
            <TabsContent value='infocliente' className='w-full bg-white'>
              <InfoCliente />
            </TabsContent>
            <TabsContent value='necessidades' className='w-full bg-indigo'>
              <ProductLev/>
            </TabsContent>
          </Tabs>)
          }
          
        </div>
      </FormProvider>
    </div>
  );
}

export default FormLev;
